import { render, staticRenderFns } from "./DynamicInputLegacy.vue?vue&type=template&id=97efcee0&"
import script from "./DynamicInputLegacy.vue?vue&type=script&lang=js&"
export * from "./DynamicInputLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports